import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormView } from '@form/cer-form-view';


export class BlobStorageTypeForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(BlobStorageTypeForm.viewGet());
  }

  public static viewGet() : CerFormView {
    var v = new CerFormView();
    v.viewMetadata = {
      dataApiName: 'BlobStorageType', primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'name', 'history']
    };
    return v;
  }
}
